<template>
  <main-template>
    <v-container class="py-6">
      <v-row>
        <v-col>
          <h1 class="d-flex align-center">
            <v-btn
              color="primary"
              small
              icon
              @click="$router.push({ name: 'eventos-calendario-letivo' })"
              class="mr-2"
            >
              <v-icon>mdi-arrow-left</v-icon>
            </v-btn>
            Painel Administrativo - {{ editing ? "Editando" : "Criando" }} Eventos
          </h1>
        </v-col>
      </v-row>

      <v-card class="mt-4" flat>
        <v-card-text>
          <v-form @submit.prevent="salvarEvento" class="mt-2">
            <v-row>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="evento.legenda"
                  label="Nome do Evento"
                  solo
                  dense
                  clearable
                  counter="40"
                  :rules="[(v) => !!v || 'Campo obrigatório']"
                ></v-text-field>
                <v-col cols="12">
                  <div class="d-flex align-center justify-space-between">
                    <div class="d-flex flex-column">
                      <span class="text-subtitle-1 font-weight-medium mb-1"> Permitir Aulas </span>
                      <span class="text-caption text--secondary">
                        {{
                          evento.is_sabado_letivo ? "Lançamento liberado" : "Lançamento bloqueado"
                        }}
                      </span>
                    </div>
                    <v-switch
                      v-model="evento.is_sabado_letivo"
                      inset
                      color="primary"
                      class="ma-0"
                    ></v-switch>
                  </div>
                </v-col>
              </v-col>
              <v-col cols="12" md="6" class="d-flex flex-column">
                <div class="text-caption text--secondary mb-2">Cor do evento</div>
                <v-color-picker
                  v-model="evento.cor"
                  dot-size="25"
                  swatches-max-height="120"
                  mode="hexa"
                  class="elevation-0 align-self-start"
                ></v-color-picker>
              </v-col>
            </v-row>

            <v-row class="mt-2">
              <v-col cols="12">
                <v-btn color="primary" :loading="submittingForm" type="submit" block>
                  {{ editing ? "Atualizar Evento" : "Cadastrar Evento" }}
                </v-btn>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
      </v-card>
    </v-container>
  </main-template>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  props: {
    editing: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      evento: {
        legenda: "",
        cor: "#FF0000",
        ano_id: null,
        is_sabado_letivo: false,
      },
      eventos: [],
      submittingForm: false,
    };
  },

  computed: {
    ...mapGetters("Auth", ["user"]),
  },

  mounted() {
    this.loadEventos().then(() => {
      this.loadDataEvento();
    });
  },

  watch: {
    user: {
      immediate: true,
      handler(newUser) {
        if (newUser && newUser.ano) {
          this.evento.ano_id = newUser.ano.id;
        }
      },
    },
  },

  methods: {
    async loadEventos() {
      try {
        this.eventos = await this.$services.eventoCalendarioLetivoService.syncAll();
      } catch (error) {
        this.$handleError(error);
      }
    },

    loadDataEvento() {
      if (!this.editing) return;
      const { evento_id } = this.$route.params;
      const evento = this.eventos.find((e) => e.id === parseInt(evento_id, 10));
      if (evento) {
        this.evento = { ...evento };
      }
    },

    async salvarEvento() {
      this.submittingForm = true;

      if (!this.evento.legenda) {
        this.$toast.danger("Por favor, informe o nome do evento.");
        this.submittingForm = false;
        return;
      }

      const eventoParaSalvar = {
        ...this.evento,
        cor:
          typeof this.evento.cor === "object" ? this.evento.cor.hex : this.evento.cor || "#FF0000",
      };

      try {
        if (this.editing) {
          await this.$services.eventoCalendarioLetivoService.atualizarEvento(eventoParaSalvar);
          this.$toast.success("Evento atualizado com sucesso!");
        } else {
          await this.$services.eventoCalendarioLetivoService.criarEvento(eventoParaSalvar);
          this.$toast.success("Evento salvo com sucesso!");
        }
        this.$router.push({ name: "eventos-calendario-letivo" });
      } catch (error) {
        this.$handleError(error);
      } finally {
        this.submittingForm = false;
      }
    },
  },
};
</script>

<style scoped>
.v-card {
  border-radius: 8px;
  border: 1px solid rgba(0, 0, 0, 0.12);
}

.v-color-picker {
  border-radius: 8px;
  border: 1px solid rgba(0, 0, 0, 0.12);
  background: transparent !important;
}

h1 {
  font-size: 1.5rem;
  font-weight: 500;
  color: #333;
}

@media (max-width: 960px) {
  .v-color-picker {
    width: 100% !important;
    max-width: 280px;
  }
}

@media (max-width: 600px) {
  h1 {
    font-size: 1.3rem;
  }

  .v-btn {
    height: 44px !important;
  }
}
</style>
